// Visual-editing onboarding clips, one per popover step (EXT-2068). Sources are
// tooltip1.mp4, tooltip2.mp4 and test.mp4 attached to the Linear issue,
// downscaled to 640px wide / 30fps and stripped of audio; the 10-hex md5
// fingerprints follow bin/upload-s3's naming.
export const VISUAL_EDITING_ONBOARDING_VIDEOS = {
  applyViaAssistant:
    'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/vcc-onboarding-apply-via-assistant.32eb23bcf7.mp4',
  elementSelection:
    'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/vcc-onboarding-element-selection.cdc82cd594.mp4',
  toolbarWithoutChat:
    'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/vcc-onboarding-toolbar-without-chat.85200a94d7.mp4',
} as const;
